
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M342.363 255.989l150.745-149.025c23.855-23.571 23.855-61.809 0-85.379-23.819-23.559-62.521-23.559-86.352 0L256 170.622 105.243 21.584c-23.832-23.559-62.52-23.559-86.352 0-23.855 23.583-23.855 61.82 0 85.379l150.745 149.025L18.892 405.016c-23.855 23.582-23.855 61.809 0 85.379 11.916 11.785 27.555 17.678 43.182 17.678 15.615 0 31.266-5.893 43.17-17.678L256 341.369l150.757 149.037c11.928 11.785 27.555 17.679 43.182 17.679 15.615 0 31.266-5.894 43.17-17.679 23.855-23.582 23.855-61.809 0-85.379L342.363 255.989z"}})])
          )
        }
      }
    